module.exports = __webpack_public_path__ + "img/photo4.fe8a2ed4.jpg";